import React, { useMemo } from 'react';
import { DetailList } from '../DetailList';
import { Skeleton } from './Skeleton';
export function SkeletonList(props) {
    const { items = 5, prefix, postfix, ...rest } = props;
    return (React.createElement(DetailList, { ...rest }, useMemo(() => Array.from({ length: items }).map((_, index) => (React.createElement(DetailList.Item, { key: index, label: React.createElement(Skeleton, null), prefix: prefix ? React.createElement(Skeleton.Avatar, { variant: "payment" }) : undefined, postfix: postfix ? React.createElement(Skeleton, { minWidth: 100 }) : undefined },
        React.createElement(Skeleton, null)))), [items, postfix, prefix])));
}
SkeletonList.displayName = 'Skeleton.List';
//# sourceMappingURL=SkeletonList.js.map